
import React, { Component } from "react";
import { Like } from 'react-facebook';

export function FacebookLike(props) {
    const { url } = props;
   return(
        <Like href={url} share layout="button_count" />
    )
}
